import Vue from "vue/dist/vue.esm.js"
import FacilitiesSearchForm from '../components/facilitiesSearchForm.vue'

new Vue({
  el: 'facilities-search-form',
  components: { FacilitiesSearchForm },
})